import { create } from "zustand";

import type { CurrentUser } from "@/types/auth";

interface AuthState {
  accessToken: string | null;
  user: CurrentUser | null;
  status: "unknown" | "authenticated" | "unauthenticated";
  setAccessToken: (accessToken: string) => void;
  setSession: (accessToken: string, user: CurrentUser) => void;
  clearSession: () => void;
  hasPermission: (permission: string) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  accessToken: null,
  user: null,
  status: "unknown",
  setAccessToken: (accessToken) => set({ accessToken }),
  setSession: (accessToken, user) => set({ accessToken, user, status: "authenticated" }),
  clearSession: () => set({ accessToken: null, user: null, status: "unauthenticated" }),
  hasPermission: (permission) => get().user?.permissions.includes(permission) ?? false,
}));
